import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

import popupImage from "assets/img/Main Images/Home/faq-img.jpg";

const HomePopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    const timer = window.setTimeout(() => setIsOpen(true), 5000);
    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="home-popup"
      role="presentation"
      onMouseDown={() => setIsOpen(false)}
    >
      <div
        className="home-popup__dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="home-popup-title"
        aria-describedby="home-popup-description"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button
          ref={closeButtonRef}
          className="home-popup__close"
          type="button"
          aria-label="Close popup"
          onClick={() => setIsOpen(false)}
        >
          <span aria-hidden="true"></span>
        </button>

        <div className="home-popup__content">
          <span className="home-popup__eyebrow">
            The future of digital experiences
          </span>
          <h2 id="home-popup-title" className="home-popup__title">
            We build experiences that inspire, engage, and
            <span> drive real results.</span>
          </h2>
          <p id="home-popup-description" className="home-popup__description">
            From immersive 3D visuals to interactive real estate walkthroughs
            and AR experiences, we transform ideas into digital realities that
            create impact.
          </p>
          <Link
            to="https://ghar360.rionick.com/"
            className="home-popup__cta tp-btnr bg-danger tp-btn-shine-effect"
          >
            Discover More About Us
            <i className="fa-regular fa-arrow-right"></i>
          </Link>
        </div>

        <div className="home-popup__media">
          <img
            src={popupImage}
            alt="A creative team collaborating in a studio"
          />
          {/* <div className="home-popup__media-label">
            <strong>Rionick Studios</strong>
            <span>Creativity powered by technology</span>
          </div> */}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default HomePopup;
